<template>
  <v-container>
    <v-card>
      <v-toolbar flat color="grey lighten-2">Environments</v-toolbar>
      <div
        v-if="$apollo.queries.listShowcaseEnvironments.loading"
        class="d-flex justify-center mb-6"
      >
        <v-progress-circular indeterminate color="grey"></v-progress-circular>
      </div>

      <div v-else-if="listShowcaseEnvironmentsErrors">
        <v-alert dense outlined type="error">
          {{ listShowcaseEnvironmentsErrors }}
        </v-alert>
      </div>
      <div v-else-if="listShowcaseEnvironments">
        <v-data-table
          :headers="headers"
          :items="listShowcaseEnvironments || []"
          :sort-by="['accountId', 'region']"
          multi-sort
          :sort-desc="[true, true]"
          no-data-text="No showcase environments."
          footer-props.items-per-page-text="Elements per site"
        >
          <template v-slot:item="{ item, expand, isExpanded }">
            <tr>
              <td>{{ item.accountId }}</td>
              <td>{{ item.region }}</td>
              <td>{{ item.stackName }}</td>
              <td>{{ item.imageId }}</td>
              <td>{{ item.status }}</td>
              <td>{{ formatDate(item.latestUpdate) }}</td>
            </tr>
          </template>

          <template slot="pageText" slot-scope="item">
            {{ item.pageStart }} von {{ item.pageStop }}
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { LIST_SHOWCASE_ENVIRONMENTS } from '../../constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import moment from 'moment'
export default {
  name: 'ShowcaseEnvironmentTable',
  props: ['showcase'],
  data: () => ({
    headers: [
      { text: 'Account', value: 'accountId', sortable: true },
      { text: 'Region', value: 'region', sortable: true },
      { text: 'Stack', value: 'stackName', sortable: true },
      { text: 'Image', value: 'imageId', sortable: true },
      { text: 'Status', value: 'status', sortable: true },
      { text: 'Latest Update', value: 'latestUpdate', sortable: true }
    ],
    listShowcaseEnvironments: [],
    listShowcaseEnvironmentsErrors: null
  }),
  methods: {
    formatDate: function(date) {
      return moment
        .utc(date)
        .local()
        .format('DD.MM.YY, HH:mm:ss')
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcaseEnvironments: {
      query: LIST_SHOWCASE_ENVIRONMENTS,
      variables() {
        return { showcaseId: this.showcase.showcaseId }
      },
      skip() {
        return !this.showcase
      },
      error(error) {
        this.listShowcaseEnvironmentsErrors = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped></style>
